import { useEffect, useState } from "react";
import api from "../api";
import "./HardwareAdmin.css";

export default function HardwareDestroyed() {
  const [hardware, setHardware] = useState([]);

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    // 🔥 Better: direct destroyed API (if exists)
    const res = await api.get("/hardware/destroyed");
    setHardware(res.data);
  };

  return (
    <div className="hardware-page">
      <div className="hardware-header">
        <h2>🗑 Destroyed Hardware</h2>
      </div>

      <div className="hardware-detail-grid">
        {hardware.map((h) => {
          // ✅ DESTROY HISTORY ENTRY
          const destroyed = h.history?.find((x) => x.action === "DESTROYED");

          return (
            <div key={h._id} className="hardware-detail-card destroyed">
              <h4 className="detail-title">{h.type}</h4>

              <p className="detail-subtitle">
                {h.productBrand} – {h.pcName}
              </p>

              <DetailRow label="Type" value={h.type} />
              <DetailRow label="Brand" value={h.productBrand} />
              <DetailRow
                label="Connection Type"
                value={h.connectionType || "-"}
              />
              <DetailRow label="Serial No" value={h.serialNo} />
              <DetailRow label="Location" value={h.location} />
              <DetailRow label="Invoice No" value={h.invoiceNo} />
              <DetailRow label="IP Address" value={h.ipAddress} />
              <DetailRow label="Vendor Name" value={h.vendorName} />
              <DetailRow label="Vendor Contact" value={h.vendorContactNo} />
              <DetailRow label="Vendor Email" value={h.vendorEmail} />
              <DetailRow
                label="Purchase Value"
                value={`₹ ${h.purchaseValue}`}
              />

              <DetailRow
                label="Purchase Date"
                value={
                  h.purchaseDate
                    ? new Date(h.purchaseDate).toLocaleDateString("en-IN", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })
                    : "-"
                }
              />

              {/* ✅ IMPORTANT PART */}
              <DetailRow
                label="Assigned To (Before Destroy)"
                value={
                  destroyed?.assignedUser
                    ? destroyed.assignedUser.name
                    : "IN STOCK"
                }
              />

              <DetailRow
                label="Destroyed On"
                value={
                  destroyed?.date
                    ? new Date(destroyed.date).toLocaleDateString("en-IN", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })
                    : "-"
                }
              />

              <DetailRow label="Destroy Reason" value={destroyed?.note} />

              <DetailRow label="Status" value="DESTROYED" />
            </div>
          );
        })}
      </div>
    </div>
  );
}

function DetailRow({ label, value }) {
  return (
    <div className="detail-row">
      <span>{label}</span>
      <strong>{value || "-"}</strong>
    </div>
  );
}
